import { TouchableOpacity, View, Image, Text, StyleSheet } from "react-native";
import LinearGradient from "react-native-web-linear-gradient";
import { MenuItem, Product } from "../../types/product";
import { colors } from "@/app/constants/styles";
import { useSelector } from "react-redux";
import { getIfItemSpicy } from "@/app/selectors/menuItem";
import { RootState } from "@/app/reducers";

type Props = Pick<
  MenuItem,
  "height" | "width" | "imageUrl" | "product" | "isCombo"
> & {
  onItemPress: (item: Product, isCombo: boolean) => void;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: 4,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.maroon,
    overflow: "hidden",
  },
  imageContainer: {
    flex: 1,
    position: "relative",
  },
  image: {
    width: "100%",
    height: "100%",
  },
  gradientContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
  },
  itemTitle: {
    position: "absolute",
    bottom: 12,
    left: 12,
    right: 12,
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "bold",
  },
  variationContainer: {
    position: "absolute",
    zIndex: 100,
    left: "5%",
    top: "7%",
    height: 20,
    width: 20,
  },
  variationImageContainer: { flex: 1 },
});

const ProductCard = (props: Props) => {
  const { height, width, imageUrl, onItemPress, product, isCombo } = props;

  const variation = useSelector((state: RootState) =>
    getIfItemSpicy(state, props),
  );

  return (
    <TouchableOpacity
      testID="productCard"
      accessible
      accessibilityRole="button"
      accessibilityLabel={`Menu item ${product.name}`}
      style={[styles.container, { height, width, maxWidth: width }]}
      onPress={() => onItemPress(product, isCombo)}
    >
      {variation && (
        <View style={styles.variationContainer} testID="variationImage">
          <Image
            resizeMode="cover"
            style={styles.variationImageContainer}
            source={{ uri: variation.imageUrl, cache: "default" }}
          />
        </View>
      )}
      <View style={styles.imageContainer}>
        <Image
          resizeMode="cover"
          style={styles.image}
          source={{ uri: imageUrl, cache: "default" }}
        />
        <LinearGradient
          start={{ x: 0.2, y: 0.5 }}
          end={{ x: 0.2, y: 0 }}
          colors={["rgba(0,0,0,0.5)", "rgba(0,0,0,0.3)", "rgba(0,0,0,0)"]}
          style={styles.gradientContainer}
        />
        <Text style={styles.itemTitle}>{product.name}</Text>
      </View>
    </TouchableOpacity>
  );
};

export default ProductCard;
